import { POST_APPOINTNET_SUCCESS } from "../actions/patientAction"


  const createAppointmentReducer = (state = [], { type,  data=[] }) => {
    switch (type) {
      case POST_APPOINTNET_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default createAppointmentReducer